import layout1Settings from './Layout1/Layout1Settings'
import layout2Settings from './Layout2/Layout2Settings'
import { themes } from '../MatxTheme/initThemes'

export const MatxLayoutSettings = {
    activeLayout: 'layout1',
    activeTheme: 'blue',
    perfectScrollbar: false,
    themes: themes,
    layout1Settings,
    layout2Settings,
    secondarySidebar: {
        show: false,
        open: false,
        theme: 'slateDark1',
    },
    footer: {
        show: false,
        fixed: false,
        theme: 'slateDark1',
    },
}
